import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  ModalActionButtonStyles,
  ModalBaseStyles,
  ModalHeader,
} from "../../Common/styles/modal";
import { errorToastMessage, toastMessage } from "../../../utils/toast";
import http from "../../../utils/http";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { setSurveyAssignmentStatus } from "../../../Redux/reducers/responseSlice";

type Props = {
  showModal: boolean;
  closeModal: () => void;
  onFinished?: () => void;
};

const FinishSurveyModal = ({ showModal, closeModal, onFinished }: Props) => {
  const [submitLoader, setSubmitLoader] = useState(false);
  const { id: studyId, participantId } = useParams();
  const dispatch = useAppDispatch();
  const surveyAssignmentId = useAppSelector(
    (state) => state.response.surveyAssignmentId
  );

  const handleConfirm = async () => {
    try {
      setSubmitLoader(true);
      await http.post(
        `/study/${studyId}/survey-responses/assignment/${surveyAssignmentId}/finish?participantId=${participantId}`
      );
      dispatch(setSurveyAssignmentStatus("completed"));
      toastMessage("success", "Survey finished successfully");
      setSubmitLoader(false);
      closeModal();
      onFinished?.();
    } catch (err) {
      setSubmitLoader(false);
      errorToastMessage(err as Error);
    }
  };

  return (
    <Modal open={showModal} onClose={closeModal}>
      <Box
        sx={{
          ...ModalBaseStyles,
          width: { xs: "96vw", md: 480 },
          minHeight: "auto",
          maxHeight: "80vh",
        }}
      >
        <ModalHeader title="Complete Survey?" onCloseClick={closeModal} />
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Do you want to complete this survey? Once submitted, the participant
          won’t be able to answer it.
        </Typography>
        <Box sx={ModalActionButtonStyles}>
          {!submitLoader ? (
            <>
              <Button variant="outlined" onClick={closeModal}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleConfirm} autoFocus>
                Complete Survey
              </Button>
            </>
          ) : (
            <CircularProgress size={25} />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default FinishSurveyModal;
